import * as types from '../mutations-types'
import {fetchGeofences, createGeofence, editGeofence, geoActiveMission} from '../../utils/api'
import {loaded} from 'vue2-google-maps'

import {createActionHelpers} from 'vuex-loading'

const {startLoading} = createActionHelpers({
  moduleName: 'loading'
})

function sortGeofences(geofences) {
  const geofencesSort = geofences.sort(function(a, b) {
    const textA = a.updatedAt
    const textB = b.updatedAt
    return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
  })
  return geofencesSort
}
// STATE
const state = {
  geofenceUpdated: 'idle',
  editingGeofence: false,
  geofenceCreated: 'idle',
  geofences: [],
  selectedGeofence: null,
  stackGeofence: [],
  showCreateEditGeofence: false,
  messageGeofence: {
    title: '',
    content: '',
    type: ''
  },
  showMessageGeofence: false,
  isUpdatingFence: false
}
// GETTERS
const getters = {
  geofenceUpdated: state => state.geofenceUpdated,
  editingGeofence: state => state.editingGeofence,
  geofenceCreated: state => state.geofenceCreated,
  getGeofences: state => state.geofences,
  getSelectedGeofence: state => state.selectedGeofence,
  stackGeofence: state => state.stackGeofence,
  showCreateEditGeofence: state => state.showCreateEditGeofence,
  messageGeofence: state => state.messageGeofence,
  showMessageGeofence: state => state.showMessageGeofence,
  isUpdatingFence: state => state.isUpdatingFence
}
// ACTIONS
const actions = {
  setGeofenceUpdated({commit}, value) {
    commit(types.GEOFENCE_UPDATED, value)
  },
  setEditingGeofence({commit}, value) {
    commit(types.SET_EDITING_GEOFENCE, value)
  },
  setGeofenceCreated({commit}, value) {
    commit(types.GEOFENCE_CREATED, value)
  },
  deselectFence({commit}) {
    commit(types.DESELECT_GEOFENCE)
  },
  async fetchGeofencesData({commit, dispatch}) {
    const response = await startLoading(dispatch, 'fetchingFences', () => {
      return fetchGeofences() // Some async job that returns Promise instance.
    })
    await loaded
    let geofences = []
    if (response) {
      geofences = response.data.map(geofence => {
        return {
          ...geofence,
          path: window.google.maps.geometry.encoding.decodePath(geofence.geostring)
        }
      })
      commit(types.FETCH_GEOFENCES, geofences)
    }
  },
  selectGeofence({commit}, geofence) {
    commit(types.SELECT_GEOFENCE, geofence)
  },
  createGeofence({commit, dispatch}, {name, path, agencies}) {
    return new Promise(async(resolve, reject) => {
      try {
        commit(types.GEOFENCE_CREATED, 'creating')
        await loaded
        let polygon = path.map(point => {
          return [point.lat(), point.lng()]
        })
        // let geostring = window.google.maps.geometry.encoding.encodePath(path)
        const {data} = await startLoading(dispatch, 'creatingFence', () => {
          // return createGeofence({name, polygon, geostring})
          return createGeofence({name, polygon, agencies})
        })
        if (data) {
          // console.log('CREATED GEOFENCE', data)
          data.path = path
          commit(types.ADD_GEOFENCE, data)
          commit(types.GEOFENCE_CREATED, 'created')
          resolve(data)
        } else reject(data)
      } catch (error) {
        commit(types.GEOFENCE_CREATED, 'error')
        // console.log('DATA', error)
        console.error(error)
        // alert('Se debe usar un nombre diferente para la Geocerca ya que existe una con el mismo nombre usado.')
      }
    })
  },
  editGeoFence({commit, dispatch}, {id, name = null, path = null}) {
    return new Promise(async(resolve, reject) => {
      try {
        commit(types.GEOFENCE_UPDATED, 'updating')
        await loaded
        let updateObject = {id}
        if (name !== null) {
          updateObject.name = name
        }
        if (path !== null) {
          let newPath = path.map(point => {
            if (typeof point.lat !== 'function') {
              return new this.google.maps.LatLng({lat: point.lat, lng: point.lng})
            }
            return point
          })
          let polygon = newPath.map(point => {
            return [point.lat(), point.lng()]
          })
          // let geostring = window.google.maps.geometry.encoding.encodePath(newPath)
          updateObject = {
            ...updateObject,
            polygon
            // geostring
          }
        }
        if (Object.keys(updateObject).length > 1) {
          const {data: updatedFence} = await startLoading(dispatch, 'updatingFence', () => {
            return editGeofence(updateObject)
          })
          // console.log('updatedFence', updatedFence)
          if (updatedFence) {
            updatedFence.path = path === null ? state.selectedGeofence.path : path
            commit(types.UPDATE_GEOFENCE, updatedFence)
            commit(types.GEOFENCE_UPDATED, 'updated')
            resolve(updatedFence)
          } else reject(updatedFence)
        }
      } catch (error) {
        commit(types.GEOFENCE_UPDATED, 'error')
        console.error(error)
      }
    })
  },
  showCreateEditGeofenceAction({commit}, value) {
    commit(types.SHOW_CREATE_GEOFENCE, value)
  },
  checkGeoActiveMission({dispatch}, id) {
    return new Promise(async(resolve) => {
      try {
        const response = await startLoading(dispatch, 'checingkGeoActiveMission', () => {
          return geoActiveMission(id)
        })
        if (response.status === 200) {
          resolve(response.data)
        }
        // console.log('RESPONSE CGAM:', response)
        resolve(response)
      } catch (error) {
        console.error('ERROR CGAM:')
        alert('EDICIÓN DE CERCA LIMITADA!\n\nEn este momento no se puede modificar la Cerca seleccionada.')
        resolve('error')
      }
    })
  },
  setMessageGeofence({commit}, payload) {
    commit(types.SET_MESSAGE_GEOFENCE, payload)
  },
  setShowMessageGeofence({commit}, value) {
    commit(types.SET_SHOW_MESSAGE_GEOFENCE, value)
  },
  setIsUpdatingFence({commit}, value) {
    commit(types.SET_IS_UPDATING_FENCE, value)
  }
}
// MUTATIONS
const mutations = {
  [types.GEOFENCE_UPDATED](state, value) {
    state.geofenceUpdated = value
  },
  [types.SET_EDITING_GEOFENCE](state, value) {
    state.editingGeofence = value
  },
  [types.GEOFENCE_CREATED](state, value) {
    state.geofenceCreated = value
  },
  [types.DESELECT_GEOFENCE](state) {
    state.selectedGeofence = null
  },
  [types.SHOW_CREATE_GEOFENCE](state, value) {
    state.showCreateEditGeofence = value
  },
  [types.REMOVE_STACK_GEOFENCE](state, index) {
    state.stackGeofence.splice(index, 1)
  },
  [types.ADD_STACK_GEOFENCE](state, geofence) {
    // console.log('GEOFENCE', geofence.path)
    state.stackGeofence.push(geofence)
    // console.log('STACK GEOFENCE', state.stackGeofence)
  },
  [types.FETCH_GEOFENCES](state, geofences) {
    const geofencesSorted = sortGeofences(geofences)
    state.geofences = geofencesSorted
  },
  [types.SELECT_GEOFENCE](state, geofence) {
    state.selectedGeofence = geofence
  },
  [types.ADD_GEOFENCE](state, geofence) {
    state.geofences.push(geofence)
    const geofencesSorted = sortGeofences(state.geofences)
    state.geofences = geofencesSorted
  },
  [types.UPDATE_GEOFENCE](state, updatedFence) {
    if (state.selectedGeofence.id === updatedFence.id) {
      state.selectedGeofence = {
        ...state.selectedGeofence,
        ...updatedFence
      }
    }
    // console.log('SELECTED GEOFENCE UPDATED', state.selectedGeofence)

    const index = state.geofences.findIndex(item => item.id === updatedFence.id)
    // console.log('INDEX GEOFENCES UPDATE', index)
    if (index !== -1) {
      state.geofences[index] = updatedFence
    }
    const geofencesSorted = sortGeofences(state.geofences)
    state.geofences = geofencesSorted
    // state.geofences.map(fence => {
    //   if (fence.id === updatedFence.id) {
    //     return {
    //       ...fence,
    //       ...updatedFence
    //     }
    //   }
    //   return fence
    // })
  },
  [types.SET_MESSAGE_GEOFENCE](state, payload) {
    state.messageGeofence = payload
  },
  [types.SET_SHOW_MESSAGE_GEOFENCE](state, value) {
    state.showMessageGeofence = value
  },
  [types.SET_IS_UPDATING_FENCE](state, value) {
    state.isUpdatingFence = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/geofences.js